var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-view-toggler"},_vm._l((_vm.views),function(view,index){return _c('BaseButton',{key:("viewButton" + index),class:[
            'base-view-toggler__button',
            { 'base-view-toggler__button--current': _vm.currentView === view }
        ],attrs:{"type":"border-none"},on:{"click":function($event){return _vm.emitViewChange(view)}}},[_vm._v(" "+_vm._s(view.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }